import { useMemo } from "react"

import { useTranslation } from "@bounce/i18n"

import type { StoreData } from "@/libs/bounce/stores/types"
import { getCityUrlPath, getStoreUrlPath } from "@/libs/router"
import type { Breadcrumb } from "@/types"

export const useBreadcrumbs = ({
  store,
  interpolations,
}: {
  store: StoreData
  interpolations: Record<string, string>
}): Breadcrumb[] => {
  const {
    t,
    i18n: { language },
  } = useTranslation("marketing-ls-store")

  const breadcrumbs = useMemo(
    () => [
      {
        id: "bounce",
        name: "Bounce",
        href: "/",
      },
      {
        id: "stores",
        name: store.city.translatedName,
        href: getCityUrlPath({ language, city: store.city }),
      },
      {
        id: "store",
        name: t("screen.storeScreen.breadcrumbs.store", "Luggage storage {STORE_NAME}", interpolations),
        href: getStoreUrlPath({ store }),
      },
    ],
    [t, store, language, interpolations],
  )

  return breadcrumbs
}
